import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { AjaxService } from '../services/ajax.service';
import { HttpRequest } from '@angular/common/http';
import { AccessTokenService } from '../services/access-token.service';
import { StorageService } from '../services/storage.service';
import { Token } from '../services/access-token.service';
import { UtilityService } from '../services/utility.service';
import { CommonDataService } from '../services/common-data.service';
import { Router } from '@angular/router';
const TOKEN_RENEWAL_TRESHOLD: number = 2 * 60; // Seconds before token should refresh
@Injectable()
export class AuthService {
    cachedRequests: Array<HttpRequest<any>> = [];
    refreshSubscription: any;
    public _isLoggedIn!: boolean;
    constructor(
        private _ajaxService: AjaxService,
        private _accesstokenService: AccessTokenService,
        private _storage: StorageService,
        private _utilityService: UtilityService,
        private _dataService: CommonDataService,
        private _route: Router) {
    }

    get isLoggedIn() {
        return this._isLoggedIn;
    }

    set isLoggedIn(value: boolean) {
        this._isLoggedIn = value;
    }

    login(username: string, password: string) {
        const headers = new HttpHeaders({
            'Content-type': 'application/json'
        });
        const params = {
            'Username': username,
            'Password': password
        };
        const options = {
            headers: headers
        };
        console.log(params.toString());
        return this._ajaxService.post('/rest/oauth/userLogin', params, options);
    }


    logout() {
        // remove user from local storage to log user out
        this._ajaxService.get('/rest/v2/user/userLogout').subscribe((res) => {
            console.log(res);
            this._accesstokenService.destroyToken();
            location.href = '/api/login/dist/index.html';
        });

        this._accesstokenService.destroyToken();
        this._dataService.userDetails = null;
        this._dataService.userDetailsObservable = null;
        this._route.navigate(['home']);

    }

    public handleAuthentication(): void {

    }

    public setSession(token: string): void {
        // authResult.expires_in = 120; // in seconds
        // Set the time that the access token will expire at
        // const expiresAt = JSON.stringify((authResult.expires_in * 1000) + Date.now());
        // this._storage.setLocalStorage('expires_at', expiresAt);
        this._accesstokenService.setTokenDetails(token);
    }

    isTokenExpring() {
        const expiresAt = JSON.parse(this._storage.getLocalStorage('expires_at') || '{}');
        return (expiresAt - TOKEN_RENEWAL_TRESHOLD * 1000) < new Date().getTime();
    }

    public isAuthenticated(): boolean {
        // Check whether the current time is past the
        // access token's expiry time
        const expiresAt = JSON.parse(this._storage.getLocalStorage('expires_at') || '{}');
        return new Date().getTime() < expiresAt;
    }

    public renewToken(): Observable<string> {
        const tokenDetails = this._accesstokenService.getTokenDetails();
        const params = new HttpParams()
            .set('grant_type', 'refresh_token')
            .set('client_id', tokenDetails.client_id)
            .set('client_secret', tokenDetails.client_secret)
            .set('redirect_uri', '')
            .set('refresh_token', tokenDetails.refresh_token);
        const headers = new HttpHeaders({
            'Content-type': 'application/x-www-form-urlencoded'
        });
        const options = {
            headers: headers
        };

        this._storage.setLocalStorage('RefreshInProgress', '1');

        return this._ajaxService.post('/rest/oauth/token', params, options).pipe(
            share(), // <========== YOU HAVE TO SHARE THIS OBSERVABLE TO AVOID MULTIPLE REQUEST BEING SENT SIMULTANEOUSLY
            map(res => {
                let token = '';
                if (!res.error) {
                    this.setSession(JSON.stringify(Object.assign({}, tokenDetails, res) as Token));
                    this._storage.removeLocalStorage('RefreshInProgress');
                    token = this._accesstokenService.getAccessToken();
                } else {
                    return this.handle401(res);
                }
                return token;
            })
        );
    }

    public handle401(res: { error: string; error_description: string; }) {
        //  Tried to refresh token  when dual loged in form other browser
        if (res.error === 'invalid_client') {
            this._accesstokenService.destroyToken();
            location.href = '/api/login/dist/index.html';
            return '';
        } else if (res.error === 'dual_login') { // Dual login
            this._accesstokenService.destroyToken();
            this._storage.setLocalStorage('dual_login', res.error_description + '');
            location.href = '/api/login/dist/index.html';
            return '';
        } else if (res.error === 'session_expired') {  // user session timeout
            this._accesstokenService.destroyToken();
            this._storage.setLocalStorage('session_expired', res.error_description + '');
            location.href = '/api/login/dist/index.html';
            return '';
        } else if (res.error === 'invalid_grant') { // Tried to refresh with outdated refresh token(two time with same token)
            const randNumber = this._utilityService.randomNumberGenerator(1, 3) * 1000;
            this._utilityService.sleep(randNumber);
            if (this.isAuthenticated()) { // Check validity of the  token
                return this._accesstokenService.getAccessToken();
            } else {
                this._accesstokenService.destroyToken();
                location.href = '/api/login/dist/index.html';
            }
        }
        this._accesstokenService.destroyToken(); // Unknown error
        location.href = '/api/login/dist/index.html';
        return '';

    }

    public scheduleRenewal() {
        // if (!this.isAuthenticated()) {
        //     return '';
        // }
        // this.unscheduleRenewal();

        // const expiresAt = JSON.parse(this._storage.getLocalStorage('expires_at')); // Retuns time when token will expire (millSeconds)

        // const source = of(expiresAt).pipe(flatMap(
        //     pexpiresAt => {
        //         const rndNumber = this.getRandomInt(TOKEN_RENEWAL_TRESHOLD, TOKEN_RENEWAL_TRESHOLD + 60);
        //         const now = Date.now();
        //         const scheduledTime = Math.max(1, pexpiresAt - now - (rndNumber * 1000));
        //         return timer(scheduledTime); // Timer takes input in millseconds
        //         // Subtarcting random seconds so that multiple browsr should not set req simultenously
        //     }));


        // this.refreshSubscription = source.subscribe(() => {
        //     this.renewToken().subscribe();
        // });
    }

    public unscheduleRenewal() {
        if (!this.refreshSubscription) {
            return '';
        }
        this.refreshSubscription.unsubscribe();
        return null;
    }

    public collectFailedRequest(request: HttpRequest<any>): void {
        this.cachedRequests.push(request);
    }

    public retryFailedRequests(): void {
        // retry the requests. this method can
        // be called after the token is refreshed
    }

    getToken(): Observable<string> {
        const token = this._accesstokenService.getAccessToken();
        return of(token);
        if (this.isAuthenticated()) {
            return of(token);
        }
        return this.renewToken();
    }
}
